//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectBody.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"AssemblyPart",1,0],[0,"BottomDeckSectionName",1,0],[0,"ReadDataSet",0,"Features.ShipDesign.ReadDataSetBuilder",0],[1,"ReferenceGeometry",0,"SelectDisplayableObjectList",0],[0,"SectionName",1,0],[0,"SectionPart",1,0],[0,"SectionType",1,0],[0,"SectionXMax",1,0],[0,"SectionXMin",1,0],[0,"SectionYMax",1,0],[0,"SectionYMin",1,0],[0,"SectionZMax",1,0],[0,"SectionZMin",1,0],[1,"ShipBodies",0,"SelectDisplayableObjectList",0],[1,"ShipBody",0,"SelectBody",0],[0,"XDatumFilter",1,0],[0,"XMaxDatumFilter",1,0],[1,"XMaxOffset",0,"Expression",0],[0,"XMinDatumFilter",1,0],[1,"XMinOffset",0,"Expression",0],[0,"YDatumFilter",1,0],[0,"YMaxDatumFilter",1,0],[1,"YMaxOffset",0,"Expression",0],[0,"YMinDatumFilter",1,0],[1,"YMinOffset",0,"Expression",0],[0,"ZDatumFilter",1,0],[0,"ZMaxDatumFilter",1,0],[1,"ZMaxOffset",0,"Expression",0],[0,"ZMinDatumFilter",1,0],[1,"ZMinOffset",0,"Expression",0]],[[["isDeckContainer"],"SetDeckContainer",{},1,0]],[]];
SPLM.Features.ShipDesign.ShipSectionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ShipSectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ShipSectionBuilder.Type = Object.freeze({
    "Manual" : "Manual", "Spreadsheet" : "Spreadsheet", "Decks" : "Decks", "None" : "None"});

SPLM.Features.ShipDesign.ShipSectionBuilder.XFilter = Object.freeze({
    "All" : "All", "TransverseFrames" : "TransverseFrames", "Bulkheads" : "Bulkheads"});

SPLM.Features.ShipDesign.ShipSectionBuilder.ZFilter = Object.freeze({
    "All" : "All", "DeckFrames" : "DeckFrames", "LongitudinalFrames" : "LongitudinalFrames"});

export default SPLM;